import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { WalletProvider } from './hooks/useWallet';
import Nav from './components/Nav';
import Dashboard from './pages/Dashboard';
import Faucet from './pages/Faucet';
import Swap from './pages/Swap';
import Bridge from './pages/Bridge';
import './index.css';
import './App.css';

export default function App() {
  return (
    <WalletProvider>
      <BrowserRouter>
        <div className="app">
          <Nav />
          <main className="main">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/faucet" element={<Faucet />} />
              <Route path="/swap" element={<Swap />} />
              <Route path="/bridge" element={<Bridge />} />
            </Routes>
          </main>
          <footer className="footer">
            <span className="mono">AMITIS NETWORK</span>
            <span className="mono muted">Chain ID: amitis-network</span>
            <a href="https://amitis.network" className="mono muted">amitis.network ↗</a>
          </footer>
        </div>
      </BrowserRouter>
    </WalletProvider>
  );
}
